<template>
  <div class="box-input">
    <el-form
      label-width="auto"
      ref="formEl"
      :model="mydata.form"
      :rules="mydata.rules"
    >
      <!-- 密码 -->
      <el-form-item prop="password">
        <el-input
          v-model="mydata.form.password"
          class="password-input"
          placeholder="请输入新密码"
          show-password
          :prefix-icon="Lock"
          autocomplete="off"
          :class="{ 'focus-border': mydata.focusPhone }"
          @focus="mydata.focusPhone = true;mydata.readonlyInput = false"
          @blur="mydata.focusPhone = false"
          :readonly="mydata.readonlyInput"
        />
      </el-form-item>

      <!-- 确认秘密 -->
      <el-form-item prop="password_confirm">
        <el-input
          v-model="mydata.form.password_confirm"
          type="password"
          placeholder="再次输入新密码"
          show-password
          :prefix-icon="Lock"
          autocomplete="off"
          :class="{ 'focus-border': mydata.focusCode }"
          @focus="mydata.focusCode = true;mydata.readonlyInput = false"
          @blur="mydata.focusCode = false"
          :readonly="mydata.readonlyInput"
        />
      </el-form-item>
    </el-form>

    <!-- 重置密码按钮 -->
    <el-button type="primary" class="submit-button" @click="resetPassword"
      >重置密码</el-button
    >
  </div>
</template>

<script setup>
import { ref, reactive } from "vue";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";
import { User, Lock } from "@element-plus/icons-vue";
import { forgetPassword } from "@/api/login/retrievePasswordLogin/index.js";
const router = useRouter();
const formEl = ref(null);
// 账号
const myphone = defineModel("myphone");

// 密码
const mycode = defineModel("mycode");

var mydata = reactive({
  btnLoading: false,

  form: {
    password: "",
    password_confirm: "",
  },
  rules: {
    password: [
      {
        required: true,
        message: "密码长度为8-16位，须使用数字、字母大/小写组合",
      },
      {
        validator: validator_password,
      },
    ],
    password_confirm: [
      {
        required: true,
        message: "请重复输入密码", //////无字段
      },
      {
        validator: validator_password_confirm,
      },
    ],
  },
  checked1: false,
  ////
  focusPhone: false,
  focusCode: false,
  readonlyInput:false
});

function validator_password(rule, value, callback) {
  // 手动验证重复输入密码的值
  formEl.value.validateField("password_confirm");
  let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,16}$/;
  if (reg.test(value)) {
    callback();
  } else {
    callback(new Error("密码长度为8-16位，须使用数字、字母大/小写组合"));
  }
}

function validator_password_confirm(rule, value, callback) {
  if (mydata.form.password === value) {
    callback();
  } else {
    callback(new Error("两次密码不一致"));
  }
}

// 重置密码
function resetPassword() {
  let obj = {
    type: localStorage.getItem("forgetPasswordType"),
    account: JSON.parse(localStorage.getItem("forgetPasswordObj")).account,
    code: JSON.parse(localStorage.getItem("forgetPasswordObj")).code,
    password: mydata.form.password,
    password_confirm: mydata.form.password_confirm,
  };
  // console.log(obj);

  formEl.value.validate((v) => {
    if (v) {
      forgetPassword(obj).then((res) => {
        // 提示弹窗
        ElMessage({
          message: res.msg,
          type: "success",
        });
        // 跳转页面
        router.push({
          path: "/login/nowLogin",
        });
      });
    }
  });
}
</script>

<style scoped lang="scss">
.box-input {
  ///////人物图标 与 锁图标
  :deep(.el-icon.el-input__icon) {
    // border:1px solid red;
    font-size: 20px;
  }

  //密码框后的小眼睛
  :deep(.el-icon.el-input__icon.el-input__password) {
    font-size: 20px;
    // color:blue;
  }

  //整个输入框
  :deep(.el-input) {
    width: 100% !important;
    height: 48px;
    border-radius: 4px;
    margin-bottom: 15px !important;
  }
  //整个输入框
  :deep(.el-input > .el-input__wrapper) {
    box-shadow: none;
    border: 1px solid #dbdbdb;
    // border: 1px solid red;
    > .el-input__inner {
      font-size: 15px;
      // color:red;
    }
  }

   :deep(.el-form-item.is-required.asterisk-left){
    // margin-top:30px;
    margin-bottom:15px;
  }

  :deep(.el-input.el-input--suffix) {
    // border:1px solid blue;
    // margin-bottom: 0px;
  }
  //输入框中提示文字
  :deep(.el-input__wrapper > .el-input__inner::placeholder) {
    color: #666666;
    font-size: 14px;
    font-weight: 300;
    // color:blue;
  }
}

//鼠标在输入框中时，边框变蓝色
.focus-border {
  :deep(.el-input__wrapper) {
    border: 1px solid #409eff !important;
    .el-icon {
      color: #409eff;
    }
  }
}
.box-input {
  :deep(.el-input) {
    margin-bottom: 0 !important;
  }
}
:deep(.el-input__wrapper) {
  box-shadow: none !important;
}


/////////////////两个按钮
:deep(.el-button) {
  width: 311px;
  height: 40px;
  font-size: 16px;
  font-weight: 400;
  border-radius: 4px;
  margin-bottom: 10px;
  cursor: pointer;
}

//两个按钮一起用会有margin-left:12px;
:deep(.el-button + .el-button) {
  margin-left: 0px;
}

:deep(.el-button.el-button--primary) {
}



// 重置密码按钮
  :deep(.el-button.el-button--primary.submit-button) {
    margin-top: 58px;
  }

</style>
